import React from 'react';
import DefaultButton from 'components/Utils/NewDefaultButton';

const FormButton = (props) => (
  <DefaultButton style={{ width: '100%', marginTop: '27px' }} {...props} />
);
export default FormButton;
